<template>
  <v-row v-if="urlsStore.urls.length > 0">
    <v-col cols="auto">
      <v-chip 
        :color="isCategoryComplete ? 'success' : 'default'"
        :variant="tabsStore.getActiveTab === Tab.CATEGORY ? 'elevated' : 'tonal'" 
        @click="tabsStore.setActiveTab(Tab.CATEGORY)"
      >
        {{ categoryText  }}
      </v-chip>
    </v-col>
    <v-col cols="auto">
      <v-chip 
        :color="isProductComplete ? 'success' : 'default'"
        :variant="tabsStore.getActiveTab === Tab.PRODUCT ? 'elevated' : 'tonal'"
        @click="tabsStore.setActiveTab(Tab.PRODUCT)"
      >
        {{ productText }}
      </v-chip>
    </v-col>
    <v-col cols="auto">
      <v-chip
        :color="isPageComplete ? 'success' : 'default'" 
        :variant="tabsStore.getActiveTab === Tab.PAGE ? 'elevated' : 'tonal'" 
        @click="tabsStore.setActiveTab(Tab.PAGE)"
      >
        {{ pageText }}
      </v-chip>
    </v-col>
    <v-col v-if="urlsStore.getNumberOfUnclassifiedUrls > 0" cols="auto">
      <v-chip  
      > 
          unclassified: {{ urlsStore.getNumberOfUnclassifiedUrls }}
      </v-chip>
    </v-col>
    <v-col v-if="urlsStore.getNumberOfOtherUrls > 0" cols="auto">
      <v-chip
        :variant="tabsStore.getActiveTab === Tab.OTHER ? 'elevated' : 'tonal'" 
        @click="tabsStore.setActiveTab(Tab.OTHER)"
      > 
        Other URLs: {{ urlsStore.getNumberOfOtherUrls }}
    </v-chip>
    </v-col>
    <v-col v-if="urlsStore.getNumberOfCategoryHubUrls > 0" cols="auto">
      <v-chip  
      :variant="tabsStore.getActiveTab === Tab.CATEGORY_HUB ? 'elevated' : 'tonal'"
      @click="tabsStore.setActiveTab(Tab.CATEGORY_HUB)"
      > 
        Category hubs: {{ urlsStore.getNumberOfCategoryHubUrls }}
      </v-chip>
    </v-col>
    <v-col cols="auto">
      <v-chip  
        :variant="tabsStore.getActiveTab === Tab.IMAGES ? 'elevated' : 'tonal'"
        @click="tabsStore.setActiveTab(Tab.IMAGES)"
      > 
          Images: {{ totalImageCount }}
      </v-chip>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { useCompleteness } from '@/composables/useCompleteness';

  import { useUrlsStore } from '@/store/urlsStore';

  import { useCategoriesStore } from '@/store/categoriesStore';
  import { useProductsStore } from '@/store/productsStore';
  import { usePagesStore } from '@/store/pagesStore';
  import { useTabsStore } from '@/store/tabsStore';

  import { Tab } from '@/enums/Tab';

  const urlsStore = useUrlsStore();
  const categoriesStore = useCategoriesStore();
  const productsStore = useProductsStore();
  const pagesStore = usePagesStore();
  const tabsStore = useTabsStore(); 

  const { isCategoryComplete, categoryText, isProductComplete, productText, isPageComplete, pageText } = useCompleteness();

  const totalImageCount = computed(() => {
    const productImages = productsStore.getNumberOfImages;
    const pageImages = pagesStore.getNumberOfImages;
    const categoryImages = categoriesStore.getNumberOfImages;
    return productImages + pageImages + categoryImages;
  });

</script>
